import styled from 'styled-components';

export default styled.div`
  background: #ffe5a3;
  padding: 15px 20px;
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  color: #04040c;
`